import axios from "axios";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import Api from "./Api";
import baseApi from "./baseApi";
import { program } from "./userStore";
import HrApi from "./HrApi";
axios.defaults.withCredentials = true;

const useServer = () => {
  const { info } = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const [user, setUser] = useState({});
  const [loggedStatus, setLoggedStatus] = useState(null);
  const [secretToken, setSecretToken] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  // chack server
  // useEffect(() => {
  //   setIsLoading(true);
  //   axios
  //     .get(`https://${Api}/app/auth/chackserver`)
  //     .then((data) => {
  //       if (data.data.status > 500 && data.data.status !== 504) {
  //         setHasError(true);

  //         console.log("error hitting");
  //       }
  //     })
  //     .catch((error) => {
  //       setHasError(true);
  //       console.log("error hitting 2");
  //     });
  // }, []);
  // get cookies
  const token = Cookies.get("token");

  // login action
  const [loginResult, setLoginResult] = useState("");
  const loginAction = (data) => {
    axios
      .post(`https://${baseApi}/auth/login`, {
        user: data.user,
        password: data.password,
        visitor_id: data?.visitor_id,
      })
      .then((data) => {
        console.log(data);

        if (data) {
          const userData = data.data.user;
          setUser(userData);
          if (data.data.status === 203) {
            swal({
              title: "User does not exist",
              icon: "warning",
              button: "Ok!",
            });
            setLoginResult(2);
          }
          if (data.data.status === 201) {
            swal({
              title: "please Insert a valid pass!",
              icon: "warning",
              button: "Ok!",
            });
            setLoginResult(2);
          }
          if (data.data.status === 202) {
            swal({
              title: "You are not authorized to access the system!",
              icon: "warning",
              button: "Ok!",
            });
            setLoginResult(2);
          }
          // console.log(data.data.user, "chack");
          sessionStorage.setItem("statusId", data.data.user?.role_id);
          setLoggedStatus(data.data.status);
          localStorage.setItem("secretToken", data.data.token);
          setSecretToken(data.data.token);
        }
      })
      .catch((error) => {
        setLoginResult(500);
        return;
      });
  };
  // get all user
  useEffect(() => {
    setLoading(true);
    let userUrl = "";
    if (token) {
      userUrl = `https://${baseApi}/auth/getLoginUser`;
    }
    axios
      .get(userUrl)
      .then((data) => {
        setUser(data.data.user);
        setLoggedStatus(data.data.status);
      })
      .catch((error) => {
        setError(error.status);
      })
      .finally(() => setLoading(false));
  }, []);

  const logoutAction = () => {
    axios
      .post(`https://${baseApi}/auth/logout`)
      .then((data) => {
        if (data) {
          setUser({});
          return 1;
        }
      })
      .catch((error) => {
        setError(error.message);
      });
    Cookies.remove("login_time");
    Cookies.remove("userId");
    Cookies.remove("token");
    Cookies.remove("Role");
    localStorage.clear();
    sessionStorage.clear();
    return 1;
  };

  // english number to bangla number convert
  const toBn = (n) => {
    if (n) {
      return `${n}`.replace(/\d/g, (d) => "০১২৩৪৫৬৭৮৯"[d]);
    } else {
      return "";
    }
  };

  // date convert function
  const dateConvert = (getInputDate, convertType) => {
    const getDate = `${getInputDate}`.slice(0, 10);
    if (convertType === 1) {
      const splitData = getDate.split("-");
      const ye = splitData[0];
      const mo = splitData[1];
      const da = splitData[2];
      return `${da}/${mo}/${ye}`;
    } else if (convertType === 2) {
      const splitData = getDate.split("-");
      const ye = splitData[0];
      const mo = splitData[1];
      const da = splitData[2];
      return `${mo}/${da}/${ye}`;
    } else if (convertType === 3) {
      const splitData = getDate.split("-");
      const ye = splitData[0];
      const mo = splitData[1];
      const da = splitData[2];
      return `${mo}-${da}-${ye}`;
    } else if (convertType === 4) {
      const localDate = getInputDate?.toLocaleDateString("es-CL");
      const splitData = localDate.split("-");
      const ye = splitData[2];
      const mo = splitData[1];
      const da = splitData[0];
      return `${ye}-${mo}-${da}T00:00:00Z`;
    } else if (convertType === 5) {
      const splitData = getDate.split("-");
      const ye = splitData[0];
      const mo = splitData[1];
      const da = splitData[2];
      return `${da}-${mo}-${ye}`;
    } else if (convertType === 6 && getDate.length) {
      const splitData = getDate.split("-");
      const ye = splitData[0];
      const mo = splitData[1];
      const da = splitData[2];
      return `${toBn(da)}/${toBn(mo)}/${toBn(ye)}`;
    } else if (convertType === 7 && getDate.length) {
      const getFormateDate = new Date(getInputDate);
      const formateDate = `${getFormateDate.toLocaleDateString("es-CL")}`.slice(
        0,
        10
      );
      const splitData = formateDate.split("-");
      const ye = splitData[2];
      const mo = splitData[1];
      const da = splitData[0];
      return `${toBn(da)}/${toBn(mo)}/${toBn(ye)}`;
    } else if (convertType === 8) {
      const splitData = getDate.split("/");
      const ye = splitData[2];
      const mo = splitData[1];
      const da = splitData[0];
      return `${da}-${mo}-${ye}`;
    } else {
      const splitData = getDate.split("-");
      const ye = splitData[2];
      const mo = splitData[1];
      const da = splitData[0];
      return `${ye}-${mo}-${da}`;
    }
  };

  // search function
  const searchFunction = (
    getData,
    getSearchData,
    getField1,
    getField2,
    getField3,
    getField4,
    getField5,
    getField6,
    getField7,
    getField8
  ) => {
    console.log(
      getData,
      getSearchData,
      getField1,
      getField2,
      getField3,
      getField4,
      getField5,
      getField6,
      getField7,
      getField8
    );

    const searchData = getData?.filter((item) => {
      if (getSearchData == "") {
        return item;
      } else if (
        (item[getField1] &&
          item[getField1]
            .toString()
            .toLowerCase()
            .includes(getSearchData.toLowerCase())) ||
        (item[getField2] &&
          item[getField2]
            .toString()
            .toLowerCase()
            .includes(getSearchData.toLowerCase())) ||
        (item[getField3] &&
          item[getField3]
            .toString()
            .toLowerCase()
            .includes(getSearchData.toLowerCase())) ||
        (item[getField4] &&
          item[getField4]
            .toString()
            .toLowerCase()
            .includes(getSearchData.toLowerCase())) ||
        (item[getField5] &&
          item[getField5]
            .toString()
            .toLowerCase()
            .includes(getSearchData.toLowerCase())) ||
        (item[getField6] &&
          item[getField6]
            .toString()
            .toLowerCase()
            .includes(getSearchData.toLowerCase())) ||
        (item[getField7] &&
          item[getField7]
            .toString()
            .toLowerCase()
            .includes(getSearchData.toLowerCase())) ||
        (item[getField8] &&
          item[getField8]
            .toString()
            .toLowerCase()
            .includes(getSearchData.toLowerCase()))
      ) {
        return item;
      }
    });

    return searchData;
  };
  // end
  return {
    user,
    setUser,
    error,
    loading,
    loginAction,
    logoutAction,
    loggedStatus,
    secretToken,
    hasError,
    dateConvert,
    searchFunction,
    toBn,
    loginResult,
  };
};
export default useServer;
